import { ReactElement } from "react";

import { useWiseOwlContext } from "../../hooks";
import PreChatUI from "./PreChatUI";

const PreChatContainer = (): ReactElement => {
  const { applicationProps } = useWiseOwlContext();

  return <PreChatUI ingress={applicationProps.ingress} />;
};

export default PreChatContainer;
